import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CONTENT } from "@/content";
import { publicGet } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import { ShareRow } from "@/components/share/ShareRow";

const W = CONTENT.home.wordOfDay;

export const WordOfDay = () => {
  const [item, setItem] = useState(null);
  const pick = useSettings().settings.site.word_of_day;
  useEffect(() => { publicGet("/featured").then(setItem).catch(() => setItem(null)); }, [pick]);
  if (!item) return null;
  return (
    <motion.section
      className="nb-card word-of-day"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.5 }}
      data-testid="word-of-day"
    >
      <div className="row-tags">
        <span className="pill">{W.label}</span>
        {item.category && <span className="pill light">{item.category}</span>}
      </div>
      <h2 className="section-title" data-testid="word-of-day-title">{item.title}</h2>
      <div className="verse-card wod-verse">
        <p className="verse-text">{item.verse_text}</p>
        <p className="verse-ref">{item.verse_reference}</p>
        {item.translation && <p className="verse-note">{item.translation}</p>}
      </div>
      {item.message && <p className="panel-line">{item.message}</p>}
      <Link to={`/library/${item.slug}`} className="text-link" data-testid="word-of-day-link">{W.more} <span aria-hidden="true">→</span></Link>
      <ShareRow item={item} />
    </motion.section>
  );
};
